import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { Rect } from "../../MyHelpers";
import { SlotGameInitData } from "../../SlotGameInitData";
import { ExpandingWildsBulk, ExpandingWildsBulkConfig, ExpandingWildsBulkFactory, ExpandingWildsBulkParam } from "../ExpandingWildBulk";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { ChangeSpeedParams, SlotGameType1 } from "../SlotGameType1";
// namespace SlotGames
// namespace SlotGames
// {

export class AncientSea3DFillingPot extends SlotGameType1 {
	constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
		super(multigameParams, initData, "AncientSea3DFillingPot");
		//this.spinnableReelsParams.topBorderWidth = 10;
		//this.spinnableReelsParams.bottomBorderWidth = 10;
	}
}